import { defineStore } from 'pinia'

export const useToastsStore = defineStore({
id: 'toasts',
state: () => ({
	toasts: {},
}),
actions: {
	sendToast ( content, style = 'normal', delay ) {
		this.toasts = {
			content: content,
			style: style, // normal, warning, danger
			delay: delay
		}
	}
}
})